export enum InOutUnits {
  mL = 'mL',

  dL = 'dL',

  L = 'L',
}
